import { useCallback, useEffect, useState, useContext } from 'react';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import Loading from '../../components/Loading';
import connectionContext from '../../context/connection/connectionContext';
import modalContext from '../../context/modal/modalContext';
import { formatAccount } from '../../helpers/formats';

type account = {
    path: string;
    address: string;
}[];

const DEFAULT_PATH = "m/44'/60'/x'/0/0";
const AccountSelectorModal = () => {
    const { closeModal } = useContext(modalContext);
    const { ledgerTransportAndResolve } = useContext(connectionContext);

    const [addresses, setAddresses] = useState<account>([]);
    const [path, setPath] = useState<string>('');

    const { eth, resolve } = ledgerTransportAndResolve;
    const onClose = useCallback(() => closeModal('accountSelectorModal'), [closeModal]);

    const cancelSelectAccount = useCallback(() => {
        onClose();
        resolve('');
    }, [onClose, resolve]);

    const selectAccount = (path: string) => {
        onClose();
        setPath(path);
        resolve(path);
    };

    useEffect(() => {
        if (path) {
            onClose();
            resolve(path);
            return;
        }

        if (!eth) return;
        (async () => {
            try {
                const accounts: account = [];
                let i = 0;
                //while loop for incrementing the default derivation_path of Ledger to get the account address
                while (i < 10) {
                    const path = DEFAULT_PATH.replace('x', String(i));
                    await eth.getAddress(path).then((account) =>
                        accounts.push({
                            path: path,
                            address: account.address,
                        })
                    );
                    i++;
                }
                setAddresses(accounts);
            } catch (error) {
                cancelSelectAccount();
                throw error;
            }
        })();
    }, [resolve, path, eth, cancelSelectAccount, onClose]);
    return (
        <CustomModal
            modalName='accountSelectorModal'
            overlayClassName='account-selector-modal'
            className='account-selector-modal'
        >
            <CustomModalHeader title='Select an Account' onClose={cancelSelectAccount} />
            <div className='account-selector-content'>
                {addresses.length ? (
                    addresses.map(({ path, address }) => (
                        <Button key={address} onClick={() => selectAccount(path)}>
                            {formatAccount(address)}
                        </Button>
                    ))
                ) : (
                    <Loading isLoading={true} text='Loading Accounts...'>
                        <></>
                    </Loading>
                )}
            </div>
        </CustomModal>
    );
};

export default AccountSelectorModal;
